import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { post, get } from '@/api/request'

export const useUserStore = defineStore('user', () => {
  const token = ref(localStorage.getItem('token') || '')
  const userInfo = ref(
    localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null
  )

  const isLogin = computed(() => !!token.value && !!userInfo.value)

  function setToken(newToken) {
    token.value = newToken
    if (newToken) localStorage.setItem('token', newToken)
    else localStorage.removeItem('token')
  }

  function setUserInfo(info) {
    userInfo.value = info
    if (info) localStorage.setItem('userInfo', JSON.stringify(info))
    else localStorage.removeItem('userInfo')
  }

  async function login(phone, code) {
    const res = await post('/auth/login/sms', { phone, code })
    setToken(res.access_token)
    setUserInfo(res.user)
    try {
      await fetchUserInfo(true)
    } catch (e) {
      console.error('[UserStore] login: 登录后获取用户信息失败', e)
    }
    return res
  }

  async function sendCode(phone) {
    return await post('/auth/send-code', { phone })
  }

  async function fetchUserInfo(force = false) {
    if (!token.value) return
    if (!force && userInfo.value) return userInfo.value
    try {
      const res = await get('/users/me', undefined, { silent: true })
      setUserInfo(res)
      return res
    } catch (error) {
      logout()
      throw error
    }
  }

  function logout() {
    token.value = ''
    userInfo.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }

  return {
    token,
    userInfo,
    isLogin,
    setToken,
    setUserInfo,
    login,
    sendCode,
    fetchUserInfo,
    logout
  }
})
